import { Pipe, PipeTransform } from '@angular/core';
import { genericStringFormatter, storageConverterRender, ongoingRenderVapp } from './common-renderers';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';

@Pipe({name: 'keyvaluePipe'})
export class KeyValuePipe implements PipeTransform {
  transform(value, args:string[]) : any {
    let keys = [];
    for (let key in value) {
      keys.push({key: key, value: value[key]});
    }
    return keys;
  }
}

@Pipe({
    name: 'filterPipe'
})
export class FilterPipe implements PipeTransform {
    transform(value: any, args: string[]): any {
        let filter = args;
        if (filter && Array.isArray(value)) {
          return value.filter( (obj) => {
            return obj.key.toLowerCase().indexOf(filter.toString().toLowerCase()) !== -1;
          });
        } else {
          return value;
        }
    }
}

@Pipe({
    name: 'statusSuccess'
})
export class StatusSuccessPipe implements PipeTransform {
    transform(value: any, args: string[]): any {
        return value.filter(item => item.status === "success");
    }
}

@Pipe({name: 'storageRenderPipe'})
export class StorageRenderPipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    transform(value): any {
        if (value && value > 0) {
            return storageConverterRender(value, 'MB');
        }
        else {
            return "0 MB";
        }
    }
}


@Pipe({name: 'dateRendererPipe'})
export class DateRendererPipe implements PipeTransform {
    transform(value): any {
        if (value) {
            return new Date(value);
        }
    }
}

@Pipe({name: 'statusStringFormatterPipe'})
export class StatusStringFormatterPipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    transform(value): any {
        if (value) {
            if (value === "success") {
                    return '<span class=\'label label-success\'>' +
                    this.translate.instant('vcDpsModule.restorePoints.grid.message.success') + '</span>';
            } else if (value === "failed") {
                    return '<span class=\'label label-danger\'>' +
                        this.translate.instant('vcDpsModule.restorePoints.grid.message.failure') + '</span>';
            } else if (value === "partialSuccess" || value === "partial") {
                    return '<span class=\'label label-success\'>' +
                    this.translate.instant('common.statuses.partial') + '</span>';
            } else if (value === "POWERED_ON") {
                    return '<span class=\'label label-success\'>' +
                    this.translate.instant('common.statuses.poweredOn') + '</span>';
            } else if (value === "POWERED_OFF") {
                    return '<span class=\'label label-danger\'>' +
                        this.translate.instant('common.statuses.poweredOff') + '</span>';
            } else {
                return '<span class=\'label label-info\'>' + value + '</span>';
            }
        } else {
            return "<span> </span>'";
        }
    }
}


@Pipe({name: 'vappStatusRenderPipe'})
export class VappStatusRenderPipe implements PipeTransform {
    transform(data): any {
        if (data) {
            return ongoingRenderVapp(null,null,data);
        }
        else {
            return '<span></span>';
        }
    }
}






// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/pipes.ts